import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=45ffde39&scoped=true&"
import script from "./Case.vue?vue&type=script&lang=js&"
export * from "./Case.vue?vue&type=script&lang=js&"
import style0 from "./Case.vue?vue&type=style&index=0&id=45ffde39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ffde39",
  null
  
)

export default component.exports